
document.addEventListener('DOMContentLoaded', function () {
  container = document.getElementById('siteHeaderSearchFaq');
  form = container.querySelector('form.searchformFaq');
  button = document.querySelector('.search-button');
  input = container.querySelector('input[type="search-faq"]');
  defaultTab = container.querySelector('.side-panel-content--initial');
  predictiveSearchResults = container.querySelector('.side-panel-content--has-tabs');
  marketingWords = container.querySelector('.marketing-words');

  button.addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementsByTagName("body")[0].classList.toggle('open-cc');
    container.classList.toggle('active');
    if (container.classList.contains('active')) {
      setTimeout(function () {
        input.focus({
          preventScroll: true
        });
      }, 100);
      dispatchCustomEvent('search:open');
    }

    onChange();

    return false;
  });

  form.addEventListener('submit', (event)=>{
    event.preventDefault();
    onChange();
  });

  function onChange() {
    const searchTerm = input.value.trim();
    if (!searchTerm.length) {
      return;
    }
    getSearchResults(searchTerm);
  }

  function onFormSubmit(event) {
      
      event.preventDefault();
      onChange();
  }

  function onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  function renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });

    searchFaq();
    searchProduct();
    tabActive();
    document.querySelector('.search-push-faq').style.display = 'block';
  }

  // function close() {
  //   container.classList.remove('active');
  // }

  function searchFaq() {
    var searchTerm = input.value.trim().toLowerCase();
    // 获取所有包含 class="search-result" 的 div 元素
    const divs = document.querySelectorAll('.faq-item');

    // 创建一个用于存储匹配结果的数组
    const faqMatchedDivs = [];

    // 遍历每个 div 元素
    divs.forEach(div => {
      // 获取当前 div 元素的搜索关键字（假设存储在 data-search 属性中）
      if (div.textContent.toLocaleLowerCase().includes(searchTerm)) {
        faqMatchedDivs.push(div);
      }
    });

    const contentTabs = document.querySelector('.side-panel-content--tabs');
    const contentInner = document.querySelector('.side-panel-content--inner');

    var contentHTML = '<div class="side-panel-content--tab-panel">';

    const tabFaq = "<button>Faq</button>";

    // 清空之前的搜索结果
    //const searchResultsContainer = document.getElementById('searchResults');
    // searchResultsContainer.innerHTML = '';

    // 如果有匹配的结果，将它们显示在页面上
    contentTabs.innerHTML += tabFaq;
    if (faqMatchedDivs.length > 0) {
      // 使用 innerHTML 插入新的按钮
      faqMatchedDivs.forEach(div => {
        contentHTML += div.outerHTML;
      });
    }

    contentHTML += '<div style="text-align:center;margin-top:10px"><a src="#" style="width:300px;background-color: #E13A2D;display: inline-block;font-size: 16px;line-height: 16px;color: white;text-align: center;border-radius: 16px;">more</a></div>';

    contentHTML += '</div>';
   
    contentInner.innerHTML += contentHTML;
  }

  function searchProduct() {
    var searchTerm = input.value.trim().toLowerCase();
    // 获取所有包含 class="search-result" 的 div 元素
    const divs = document.querySelectorAll('.product-content .product-item');

    // 创建一个用于存储匹配结果的数组
    const productMatchedDivs = [];

    // 遍历每个 div 元素
    divs.forEach(div => {
      // 获取当前 div 元素的搜索关键字（假设存储在 data-search 属性中）
      if (div.textContent.toLocaleLowerCase().includes(searchTerm)) {
        productMatchedDivs.push(div);
      }
    });

    const contentTabs = document.querySelector('.side-panel-content--tabs');
    const contentInner = document.querySelector('.side-panel-content--inner');

    var contentHTML = '<div class="side-panel-content--tab-panel "><div class="product-list">';

    const tabProduct = "<button>Products Support</button>";

    // 清空之前的搜索结果
    //const searchResultsContainer = document.getElementById('searchResults');
    // searchResultsContainer.innerHTML = '';

    // 如果有匹配的结果，将它们显示在页面上
    contentTabs.innerHTML += tabProduct;
    if (productMatchedDivs.length > 0) {
      // 使用 innerHTML 插入新的按钮
      productMatchedDivs.forEach(div => {
        contentHTML += div.outerHTML;
      });
    }
    contentHTML += '</div>';

    contentHTML += '<div style="text-align:center"><a src="#" style="width:300px;background-color: #101820;display: inline-block;font-size: 16px;line-height: 16px;color: white;text-align: center;border-radius: 16px;">more</a></div>';

    contentHTML += '</div>';
    contentInner.innerHTML += contentHTML;
  }

  function tabActive() {
    // 获取所有的按钮和面板
    const buttons = document.querySelectorAll('.side-panel-content--tabs button');
    const panels = document.querySelectorAll('.side-panel-content--tab-panel');
    // 默认给第一个按钮和面板增加 tab-active 类
    if (buttons.length > 0) {
      buttons[0].classList.add('tab-active');
    }
    if (panels.length > 0) {
      panels[0].classList.add('tab-active');
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // 移除所有按钮的 tab-active 类
        buttons.forEach((btn) => btn.classList.remove('tab-active'));
        // 为点击的按钮添加 tab-active 类
        button.classList.add('tab-active');

        // 移除所有面板的 tab-active 类
        panels.forEach((panel) => panel.classList.remove('tab-active'));
        // 为对应顺序的面板添加 tab-active 类
        panels[index].classList.add('tab-active');
      });
    });
  }
});